export class UserTagModel {
  tagId: number;
  tag: string;
  tagType: string;
  folderId: number;
}
